// Copyright (c) 2019 Comsearch, Inc., All rights reserved

export default {
  monthlyReports: {
    dataExpiration: null,
    licensees: [],
    reportCodes: [],
    reports: [],
  },
  protectionMetrics: {
    dataExpiration: null,
    data: [],
  },
  rcn: {
    dataExpiration: null,
    data: [],
  },
}
